module.exports = __webpack_public_path__ + "img/7de7b7ae354852188b1db3a46691abca.png";